import styled from "styled-components";

import type { ClientCertificate as ClientCertificateType } from "../../types";
import { Typography } from "../atoms/Typography";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";
import { Snackbar } from "../atoms/Snackbar";
import { Button } from "../atoms/Button";
import { ConfirmModal } from "../../containers/organisms/modal/ConfirmModal";
import okIcon from "../../assets/icons/ok.png";
import errorIcon from "../../assets/icons/alert.png";
import { SnackBarType } from "../../types";

/**
 * ClientCertificate Component
 */
type ClientCertificateProps = {
  clientCertificate: Pick<ClientCertificateType, "name">;
  handleGetClientCertificatePassword: () => void;
  handleCopyPasswordToClipboard: (password: string) => void;
  onCancelButtonClick: () => void;
  isOpen: boolean;
  loading: boolean;
  password: string;
  snackBar: SnackBarType;
  closeModal: () => void;
};

const ClientCertificatePasswordButtonWrapper = styled.div`
  width: 200px;
  height: 30px;
  margin-left: auto;
`;

export function ClientCertificate({
  clientCertificate,
  handleGetClientCertificatePassword,
  handleCopyPasswordToClipboard,
  isOpen,
  password,
  snackBar,
  loading,
  closeModal,
}: ClientCertificateProps) {
  const flexRatio = [3, 1];
  const headerTitles = ["クライアント証明書名"];
  const item = [
    <DataListRow flexRatio={flexRatio}>
      <DataListBodyItem>
        <Typography size={2} withEllipsis={true}>
          {clientCertificate.name}
        </Typography>
      </DataListBodyItem>
      <DataListBodyItem>
        <ClientCertificatePasswordButtonWrapper>
          <Button
            buttonType="primary"
            onClick={handleGetClientCertificatePassword}
          >
            パスワードを確認する
          </Button>
        </ClientCertificatePasswordButtonWrapper>
      </DataListBodyItem>
    </DataListRow>,
  ];

  return (
    <>
      <DataTable>
        <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
        {item && <DataListBody rows={item} />}
      </DataTable>
      <ConfirmModal
        isOpen={isOpen}
        value={password}
        isLoading={loading}
        title={`${clientCertificate.name}のパスワードをクリップボードにコピーしますか？`}
        onChangeClick={() => handleCopyPasswordToClipboard(password)}
        closeModal={() => closeModal()}
      />
      {!!snackBar && (
        <Snackbar
          isOpen={snackBar.isOpen}
          icon={
            <img
              src={snackBar.type === "ok" ? okIcon : errorIcon}
              width="18"
              height="18"
              alt={snackBar.type}
            />
          }
          text={snackBar.message}
          close={snackBar.close}
        />
      )}
    </>
  );
}
